"use client";
import React, { useEffect, useRef, useState } from "react";
import {Plus } from "lucide-react";
import { Action, TypeLayout } from "@/app/constants/enums";
import ConversationManager, { ConversationManagerRef } from "./ConversationManager";
import ButtonChat from "../Elements/Core/ButtonChat";
import Accordion from "../Elements/Accordion";


 


const ConversationView = () => {
    // conversatio acordion
    const [openAccordionConv, setOpenAccordionConv] = useState<boolean>(true);   
    const convManagerRef = useRef<ConversationManagerRef>(null);

  return (
    <div className="w-full h-full ml-1"> 
       <Accordion
            title="Conversaciones"
            index={0}
            isOpen={openAccordionConv}
            onClick={()=>setOpenAccordionConv(!openAccordionConv)}
            classNameHead="border-b py-3"
            classNameBody="p-1"
            rightComponent={""/*
                <div className="flex items-center">
                <ButtonChat
                    actionCode={Action.LEFT_CONVERSATION_ADD}
                    type="button"
                    onClick={() => convManagerRef.current?.handleAdd()}  
                    className=" rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out flex-shrink-0 "
                >
                    <Plus strokeWidth={1} className="m-2" />
                </ButtonChat>
                </div>*/
            }
            viewChevron={false}
            >
                <ConversationManager ref={convManagerRef} />
            </Accordion>
     
    </div>
  );
};

export default ConversationView;
